<template>
  <div class="location-info">
    <h2>Dove siamo</h2>
    <div class="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2995.5896754716514!2d14.1050309!3d41.339535100000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133af3ea191166c7%3A0x38ee5c136e037a1a!2sSapori%20Miei!5e0!3m2!1sit!2sit!4v1710952520938!5m2!1sit!2sit"
        width="100%" height="250px" style="border:0;" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
      <div class="info">
        
      <p><strong>Indirizzo:</strong> Strada Statale N 85 Venafrana, KM. 2.400 81058 Vairano Patenora (CE)</p>
      <p><strong>Orari di Apertura:</strong> Mar-Dom: 12:00 - 15:00 / 19:00 - 23:30 | Lun: chiuso</p>
      <p><strong>Telefono:</strong> 0823 1830119</p>
      <p><strong>Email:</strong> dariocalce91@gmail.com</p>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationInfo',
}
</script>

<style scoped>
.location-info {
  background-color: var(--background-color);
  color: var(--text-color);
  padding: 40px 20px;
  text-align: center;
}

.location-info h2 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.location-info .info {
  text-align: left;
}

.location-info .info p {
  margin-bottom: 10px;
}

.location-info .map-container {

  margin-top: 20px;
}
</style>
